import React from 'react';
import { ModalFooter, Button, HStack } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';

interface Props {
  onClose: () => void;
  onSubmit: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  showTryAgain?: boolean;
}

const PackageEditModalFooter: React.FC<Props> = ({
  onSubmit,
  onClose,
  isDisabled,
  isLoading,
  showTryAgain = false,
}) => {
  const { t } = useTranslation();

  return (
    <ModalFooter as={HStack} justify="flex-end">
      <Button variant="grayedGhost" onClick={onClose}>
        {t('CANCEL')}
      </Button>

      <Button onClick={onSubmit} isDisabled={isDisabled} isLoading={isLoading}>
        {showTryAgain ? t('TRY-AGAIN') : t('SAVE-AND-CLOSE')}
      </Button>
    </ModalFooter>
  );
};

export default PackageEditModalFooter;
